export const BRAND_V2_HOSTS: string[] = [
  // arrangementer.dn.dk uses V2 components (represented in classname form)
  'arrangementer-dn-dk',
  'lokaleevents-dn-dk',
  'mineindsamlinger-affaldsindsamlingen-dk',
  'events-affaldsindsamlingen-dk',
]

export const BRAND_V1_HOSTS: string[] = [
  'events-dn-dk',
  'events-naturensuge-dk',
  'mineture-tidtiltur-dk'
]
